import type { FormState, UseFormReturn } from 'react-hook-form';
import type { AnySchema } from 'yup';

import { useEffect } from 'react';

type TButtonlessFlowFunction = (props: {
  form: {
    handleSubmit: UseFormReturn['handleSubmit'];
    getValues: UseFormReturn['getValues'];
    formState: Pick<FormState<any>, 'isDirty' | 'isValid'>;
  };
  schema: AnySchema;
  onSubmit: (data: any) => any | Promise<any>;
  disabled?: boolean;
}) => void;

const useButtonlessFlow: TButtonlessFlowFunction = ({
  form,
  schema,
  onSubmit,
  disabled = false,
}) => {
  useEffect(() => {
    const executeOnSubmitMethod = async () => {
      try {
        const result = await schema.validate(form.getValues());
        if (result) {
          await form.handleSubmit(onSubmit)();
        }
      } catch (e) {
        // TODO: We can set here form validation error if needed
      }
    };

    if (form.formState.isDirty && !disabled) {
      executeOnSubmitMethod();
    }
  }, [form.formState.isDirty, form.formState.isValid, disabled]);
};

export default useButtonlessFlow;
